import dayjs from 'dayjs';

export const MOBILE_REGEX =/[^0-9]/g;

export const validateEmail = (email, setShowEmailError, setIsValidEmail)=>{
    const EMAIL_REGEX =/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/;
    if (EMAIL_REGEX.test(email)) {
        setShowEmailError(false);
        setIsValidEmail(true);
    } else {
        setShowEmailError(true);
        setIsValidEmail(false);
    }
};

export const validatePassword = (password, setShowPasswordError, setIsValidPassword)=>{
    setShowPasswordError((password === ""));
    setIsValidPassword((password !== ""));
}

export const validateName = (name, setShowNameError, setIsValidName)=>{
    setShowNameError((name === ""));
    setIsValidName(!(name === ""));
}

export const validateMobileNum = (mobileNum, setShowMobileNumError, setIsValidMobileNum)=>{
    setShowMobileNumError((mobileNum.length !== 10))
    setIsValidMobileNum((mobileNum.length === 10))
}

const dobValidRange = (dob) => {
    const today = dayjs();
    const date = dayjs(dob, 'DD/MM/YYYY');
    const age = today.diff(date, 'year');
    return date.isValid() && age >= 15 && age <= 100;
}

export const validateDob = (dob, setShowDobError, setIsValidDob) => {
    if (dobValidRange(dob)) {
        setShowDobError(false);
        setIsValidDob(true);
    } else {
        setShowDobError(true)
        setIsValidDob(false);
    }
}

export const validateAddress = (country, state, city, setShowCountryError, setIsValidCountry, setShowStateError, setIsValidState, setShowCityError, setIsValidCity) => {
    setShowCountryError((country === ""));
    setIsValidCountry(!(country === ""));
    setShowStateError((state === ""));
    setIsValidState(!(state === ""));
    setShowCityError((city === ""));
    setIsValidCity(!(city === ""));
  }

export const validateConfirmPassword = (confirmPassword, newPassword, setShowConfirmPasswordError, setIsValidCounfirmPassword, setPasswordMatchError) => {
    if (confirmPassword === "") {
        setShowConfirmPasswordError(true);
        setIsValidCounfirmPassword(false);
    } else {
        setShowConfirmPasswordError(false);
        if (confirmPassword !== newPassword) {
            setPasswordMatchError(true);
            setIsValidCounfirmPassword(false);
        } else {
            setPasswordMatchError(false);
            setIsValidCounfirmPassword(true);
        }
    }
};
